(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  /* ----------------- Video behavior ----------------- */
  const items = document.querySelectorAll(".ugc-item");
  let currentVideo = null;

  // Autoplay 3rd video muted (index 2), pause when out of view, resume when visible
  const middleIndex = 2;
  const middleItem = items[middleIndex];
  const middleVideo = middleItem ? middleItem.querySelector(".ugc-video") : null;
  if (middleVideo) {
    middleVideo.muted = true;
    middleVideo.play().catch(()=>{ /* autoplay might be blocked; ok to ignore */ });
    currentVideo = middleVideo;
    const btn = middleItem.querySelector(".ugc-play-btn");
    if (btn) btn.style.display = "none";
  }

  // Play/pause with overlay buttons; ensure only one plays at a time
  items.forEach(item => {
    const video = item.querySelector(".ugc-video");
    const btn = item.querySelector(".ugc-play-btn");
    if (!video || !btn) return;

    btn.addEventListener("click", () => {
      if (currentVideo && currentVideo !== video) {
        currentVideo.pause();
        const prevBtn = currentVideo.parentElement.querySelector(".ugc-play-btn");
        if (prevBtn) prevBtn.style.display = "block";
      }
      video.muted = false; // user intent play -> allow sound
      video.play();
      currentVideo = video;
      btn.style.display = "none";
    });

    video.addEventListener("pause", () => {
      if (video !== middleVideo) btn.style.display = "block";
    });
  });

  // Pause/resume middle video with IntersectionObserver
  if (middleVideo && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && !middleVideo.paused) {
          middleVideo.pause();
        } else if (entry.isIntersecting && middleVideo.paused) {
          middleVideo.play().catch(()=>{});
        }
      });
    }, { threshold: 0.5 });
    observer.observe(middleVideo);
  }

  /* ----------------- Cart add + header refresh ----------------- */
  const selectorsToUpdate = [
    '[data-cart-count]',                       // common data attr
    '#cart-count-bubble',                      // sometimes used as id
    '.cart-count-bubble',                      // Dawn/Broadcast-style bubble
    '.header__cart-count',                     // alt header count class
    '.cart-link__bubble',                      // some Broadcast presets
    '.icon-bubble',                            // generic bubble class
    '.js-cart-count'                           // older themes
  ];

  function updateCartBadges(count) {
    const label = `${count} ${count === 1 ? 'item' : 'items'}`;
    document.querySelectorAll(selectorsToUpdate.join(',')).forEach(el => {
      // If bubble contains two spans like Dawn/Broadcast
      const ariaSpan = el.querySelector('[aria-hidden="true"]') || el.querySelector('[aria-hidden=true]');
      const srSpan = el.querySelector('.visually-hidden, .sr-only');
      if (ariaSpan) ariaSpan.textContent = count;
      if (srSpan) srSpan.textContent = label;

      // Fallback: put count directly
      if (!ariaSpan && !srSpan) el.textContent = count;

      // Show/Hide when zero
      el.style.display = count > 0 ? '' : 'none';
      el.classList.toggle('is-empty', count === 0);
    });
  }

  async function fetchCartJSON() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  // Try to refresh common sections via Section Rendering API
  async function refreshHeaderSections() {
    // These ids are safe to request; API ignores non-existing ids
    const sectionIds = ['cart-icon-bubble','header','cart-drawer'];
    const url = `/?sections=${encodeURIComponent(sectionIds.join(','))}`;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return;

      const htmlMap = await res.json();

      // Helper: replace element with same id from new HTML
      const replaceFromHTML = (targetId, html) => {
        if (!html) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newByExact = doc.getElementById(targetId);
        const newByShopify = doc.querySelector(`#shopify-section-${targetId}`);
        const targetByExact = document.getElementById(targetId);
        const targetByShopify = document.getElementById(`shopify-section-${targetId}`);

        const newEl = newByExact || newByShopify;
        const oldEl = targetByExact || targetByShopify;

        if (newEl && oldEl) {
          oldEl.replaceWith(newEl);
        } else if (targetByExact && html) {
          // As a fallback, inject contents
          targetByExact.innerHTML = html;
        }
      };

      Object.keys(htmlMap).forEach(key => {
        replaceFromHTML(key, htmlMap[key]);
      });
    } catch (e) {
      // Silently ignore; manual badge update still covers the UX
      console.warn('Section refresh skipped', e);
    }
  }

  // Fire common theme events (covers some Broadcast internals)
  function broadcastCartEvents(cartObj) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartObj } }));
      document.dispatchEvent(new CustomEvent('cart:change',  { detail: { cart: cartObj } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartObj } }));
      window.dispatchEvent(new CustomEvent('cart:updated',   { detail: { cart: cartObj } }));
      window.dispatchEvent(new CustomEvent('cart:change',    { detail: { cart: cartObj } }));
      window.dispatchEvent(new CustomEvent('cart:refresh',   { detail: { cart: cartObj } }));
      // Some Broadcast builds expose a cart helper - call if present
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      }
    } catch (e) {
      /* no-op */
    }
  }

  async function hardRefreshCartUI() {
    const cart = await fetchCartJSON();
    updateCartBadges(cart.item_count);
    await refreshHeaderSections();
    broadcastCartEvents(cart);
  }

  // Bind add-to-cart buttons
  document.querySelectorAll(".add-to-cart-btn").forEach(btn => {
    btn.addEventListener("click", async () => {
      const id = btn.dataset.productId;
      if (!id) return;

      const originalLabel = btn.textContent;
      btn.disabled = true;

      try {
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ id, quantity: 1 })
        });

        if (!addRes.ok) throw new Error('Add to cart failed');

        // Immediately reflect count (optimistic + verified)
        await hardRefreshCartUI();

        // Nice little feedback on the button
        btn.textContent = "✔";
        setTimeout(() => { btn.textContent = originalLabel; }, 1200);
      } catch (err) {
        console.error("Add to cart failed", err);
        btn.textContent = "!";
        setTimeout(() => { btn.textContent = originalLabel; }, 1500);
      } finally {
        btn.disabled = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    

  (function () {

    function initStickyAtc(bar) {

      if (!bar || bar.dataset.stickyAtcInitialized === 'true') {
        return;
      }

      bar.dataset.stickyAtcInitialized = 'true';


      /*
       * Move the sticky bar to body.
       */

      if (bar.parentElement !== document.body) {
        document.body.appendChild(bar);
      }


      var root =
        (window.Shopify &&
          Shopify.routes &&
          Shopify.routes.root) ||
        '/';


      var productId =
        Number(bar.dataset.productId);

      var currentVariantId =
        bar.dataset.variantId;


      var revealPercent =
        parseFloat(
          bar.dataset.revealPercent
        ) || 10;

      var releasePercent =
        parseFloat(
          bar.dataset.releasePercent
        ) || 20;


      var inCartWrapEl =
        bar.querySelector(
          '[data-sticky-atc-in-cart]'
        );

      var inCartCountEl =
        bar.querySelector(
          '[data-sticky-atc-in-cart-count]'
        );

      var qtyInput =
        bar.querySelector(
          '[data-sticky-atc-qty-input]'
        );

      var qtyDecrease =
        bar.querySelector(
          '[data-sticky-atc-qty-decrease]'
        );

      var qtyIncrease =
        bar.querySelector(
          '[data-sticky-atc-qty-increase]'
        );

      var submitBtn =
        bar.querySelector(
          '[data-sticky-atc-submit]'
        );

      var submitText =
        bar.querySelector(
          '[data-sticky-atc-submit-text]'
        );


      /*
       * Scroll behaviour
       */

      var ticking = false;

      function updatePosition() {

        var doc =
          document.documentElement;

        var scrollY =
          window.scrollY ||
          doc.scrollTop ||
          0;

        var viewportHeight =
          window.innerHeight;

        var fullHeight =
          doc.scrollHeight;

        var maxScroll =
          Math.max(
            fullHeight - viewportHeight,
            1
          );

        var scrolledPercent =
          (scrollY / maxScroll) * 100;


        if (
          scrolledPercent >=
          revealPercent
        ) {

          bar.classList.add(
            'is-visible'
          );

        } else {

          bar.classList.remove(
            'is-visible'
          );

        }


        if (
          scrolledPercent >=
          100 - releasePercent
        ) {

          if (
            !bar.classList.contains(
              'is-released'
            )
          ) {

            bar.classList.add(
              'is-released'
            );

            var barHeight =
              bar.offsetHeight;

            bar.style.position =
              'absolute';

            bar.style.bottom =
              'auto';

            bar.style.top =
              (
                fullHeight -
                barHeight
              ) + 'px';

          }

        } else {

          bar.classList.remove(
            'is-released'
          );

          bar.style.position = '';
          bar.style.top = '';
          bar.style.bottom = '';

        }

        ticking = false;

      }


      function onScrollOrResize() {

        if (!ticking) {

          window.requestAnimationFrame(
            updatePosition
          );

          ticking = true;

        }

      }


      window.addEventListener(
        'scroll',
        onScrollOrResize,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        onScrollOrResize
      );

      window.addEventListener(
        'load',
        updatePosition
      );

      updatePosition();


      /*
       * Quantity selector
       */

      if (
        qtyDecrease &&
        qtyIncrease &&
        qtyInput
      ) {

        qtyDecrease.addEventListener(
          'click',
          function () {

            var current =
              parseInt(
                qtyInput.value,
                10
              ) || 1;

            qtyInput.value =
              Math.max(
                1,
                current - 1
              );

          }
        );


        qtyIncrease.addEventListener(
          'click',
          function () {

            var current =
              parseInt(
                qtyInput.value,
                10
              ) || 1;

            qtyInput.value =
              current + 1;

          }
        );


        qtyInput.addEventListener(
          'change',
          function () {

            var value =
              parseInt(
                qtyInput.value,
                10
              ) || 1;

            qtyInput.value =
              Math.max(
                1,
                value
              );

          }
        );

      }


      /*
       * Cart count
       */

      function refreshCartCount() {

        if (
          !inCartCountEl &&
          !inCartWrapEl
        ) {
          return Promise.resolve();
        }


        return fetch(
          root + 'cart.js',
          {
            headers: {
              Accept:
                'application/json'
            }
          }
        )

        .then(function (response) {

          if (!response.ok) {
            throw new Error(
              'Cart request failed'
            );
          }

          return response.json();

        })

        .then(function (cart) {

          var quantity =
            cart.items
              .filter(function (item) {

                return (
                  Number(
                    item.product_id
                  ) === productId
                );

              })
              .reduce(
                function (
                  total,
                  item
                ) {

                  return (
                    total +
                    item.quantity
                  );

                },
                0
              );


          if (inCartCountEl) {

            inCartCountEl.textContent =
              quantity;

          }


          if (inCartWrapEl) {

            inCartWrapEl.hidden =
              quantity === 0;

          }

        })

        .catch(function () {});

      }


      refreshCartCount();


      document.addEventListener(
        'visibilitychange',
        function () {

          if (
            document.visibilityState ===
            'visible'
          ) {

            refreshCartCount();

          }

        }
      );


      /*
       * Loading state
       */

      function setLoading(
        isLoading
      ) {

        if (!submitBtn) {
          return;
        }

        submitBtn.classList.toggle(
          'is-loading',
          isLoading
        );

        submitBtn.disabled =
          isLoading;

      }


      /*
       * Button message
       */

      function flashMessage(
        message,
        revertAfter
      ) {

        if (!submitText) {
          return;
        }

        var original =
          submitText.textContent;

        submitText.textContent =
          message;

        window.setTimeout(
          function () {

            submitText.textContent =
              original;

          },
          revertAfter || 1500
        );

      }


      /*
       * Add to cart
       */

      if (submitBtn) {

        submitBtn.addEventListener(
          'click',
          function () {

            if (
              submitBtn.disabled
            ) {
              return;
            }


            var quantity =
              qtyInput
                ? (
                    parseInt(
                      qtyInput.value,
                      10
                    ) || 1
                  )
                : 1;


            setLoading(true);


            fetch(
              root + 'cart/add.js',
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json'
                },

                body: JSON.stringify({
                  items: [
                    {
                      id: Number(
                        currentVariantId
                      ),

                      quantity:
                        quantity
                    }
                  ]
                })
              }
            )

            .then(function (response) {

              return response
                .json()
                .then(function (data) {

                  if (!response.ok) {

                    throw new Error(
                      data.description ||
                      data.message ||
                      'Could not add to cart'
                    );

                  }

                  return data;

                });

            })

            .then(function () {

              refreshCartCount();

              flashMessage(
                'Added ✓',
                1500
              );


              document.dispatchEvent(
                new CustomEvent(
                  'cart:update',
                  {
                    bubbles: true
                  }
                )
              );


              document.dispatchEvent(
                new CustomEvent(
                  'theme:cart:refresh',
                  {
                    bubbles: true
                  }
                )
              );


              if (
                window.publish
              ) {

                window.publish(
                  'cart-update',
                  {
                    source:
                      'sticky-atc'
                  }
                );

              }

            })

            .catch(function (error) {

              flashMessage(
                error.message ||
                'Error',
                2500
              );

            })

            .finally(function () {

              setLoading(false);

            });

          }
        );

      }


      /*
       * Variant changes
       */

      document.addEventListener(
        'change',
        function (event) {

          if (
            event.target &&
            event.target.matches(
              '[name="id"]'
            )
          ) {

            currentVariantId =
              event.target.value;

            bar.dataset.variantId =
              currentVariantId;

          }

        }
      );

    }


    function initAllStickyAtc() {

      document
        .querySelectorAll(
          '[data-sticky-atc]'
        )
        .forEach(
          initStickyAtc
        );

    }


    if (
      document.readyState ===
      'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        initAllStickyAtc
      );

    } else {

      initAllStickyAtc();

    }


    /*
     * Shopify Theme Editor
     */

    document.addEventListener(
      'shopify:section:load',
      function (event) {

        var section =
          event.target;

        if (!section) {
          return;
        }

        section
          .querySelectorAll(
            '[data-sticky-atc]'
          )
          .forEach(
            initStickyAtc
          );

      }
    );

  })();


  } catch(e) { console.error(e); }
})();
})();
